import axios from './axios-login';

const logar = (loginData) => axios.post('/auth/login', loginData);

export default {
  logar,
};
